import { put, takeEvery } from 'redux-saga/effects';
import { path } from 'ramda';

import { logout } from 'actions/appActions';

const REQUEST_ERROR = /\w+_ERROR$/g;

export default function* error() {
    yield takeEvery((action) => REQUEST_ERROR.test(action.type), function* ({ payload }) {
        const error = path(['data', 'error'], payload);
        const sessionIsOver = error === 'EXPIRED_JWT_TOKEN';

        if (sessionIsOver) {
            yield put(logout());
        }
    });
}



// WEBPACK FOOTER //
// ./src/sagas/error.js